/**
 * 객체의 프로퍼티 중 빈 문자열, `undefined`, 또는 `null` 값을 제거한 새 객체를 반환
 * 값이 문자열인 경우, 공백을 제거한(trim) 결과를 포함
 *
 * @template T - 반환할 객체의 타입.
 * @param {object} obj - 필터링할 입력 객체.
 * @returns {T} 필터링된 프로퍼티만 포함된 새 객체.
 *
 * @example
 * const input = {
 *   name: " John Doe ",
 *   age: 25,
 *   email: "",
 *   address: undefined,
 *   phone: null
 * };
 *
 * const result = filterObject<typeof input>(input);
 * result: { name: "John Doe", age: 25 }
 */
// export function filterObject<T>(obj: object): T {
//   return Object.fromEntries(
//     Object.entries(obj)
//       .filter(([key, value]) => value !== '' && value !== undefined && value !== null)
//       .map(([key, value]) => (typeof value === 'string' ? [key, value.trim()] : [key, value]))
//   ) as T;
// }
// export function filterObject<T extends Record<string, any>>(obj: T, blacklist: (keyof T)[] = []): T {
//   const result: Partial<T> = {};

//   for (const key in obj) {
//     const value = obj[key];

//     if (blacklist.includes(key as keyof T)) {
//       result[key] = value;
//       continue;
//     }

//     if (value !== '' && value !== undefined && value !== null) {
//       result[key] = typeof value === 'string' ? value.trim() : value;
//     }
//   }

//   return result as T;
// }

type FilterRule = {
  allowNull?: boolean;
  allowUndefined?: boolean;
  allowEmptyString?: boolean;
  skipTrim?: boolean;
};

type FilterRules<T> = Partial<Record<keyof T, FilterRule>>;

export function filterObject<T extends Record<string, any>>(obj: T, rules: FilterRules<T> = {}): T {
  const result: Partial<T> = {};

  for (const key in obj) {
    const value = obj[key];
    const rule = rules[key] || {};

    const shouldSkip =
      (rule.allowNull !== true && value === null) ||
      (rule.allowUndefined !== true && value === undefined) ||
      (rule.allowEmptyString !== true && value === '');

    if (shouldSkip) continue;

    if (typeof value === 'string' && rule.skipTrim !== true) {
      result[key] = value.trim();
    } else {
      result[key] = value;
    }
  }

  return result as T;
}

export function getFilteredObject<T extends object>(target: T) {
  const filtered = filterObject<T>(target);
  const isEmpty = Object.keys(filtered).length === 0;
  return { filtered, isEmpty };
}
